/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */
export var durationStep = 25;
export var durations = {
  none: 0,
  small: 100,
  medium: 350,
  large: 700
};

/**
 * Used to multiply the initial duration for exiting motions.
 */
var EXITING_MOTION_MULTIPLIER = 0.5;
export var exitingDurations = {
  none: durations.none,
  small: durations.small * EXITING_MOTION_MULTIPLIER,
  medium: durations.medium * EXITING_MOTION_MULTIPLIER,
  large: durations.large * EXITING_MOTION_MULTIPLIER
};